var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationWarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .782c1.14 0 2.181.578 2.786 1.546l4.718 7.562a3.285 3.285 0 0 1-2.786 5.016H3.282A3.285 3.285 0 0 1 .496 9.89l4.718-7.562A3.265 3.265 0 0 1 8 .782Zm0 .937c-.814 0-1.558.413-1.99 1.105L1.29 10.387a2.346 2.346 0 0 0 1.99 3.582h9.438a2.346 2.346 0 0 0 1.99-3.582L9.99 2.824A2.333 2.333 0 0 0 8 1.72Zm0 .938a1.4 1.4 0 0 1 1.195.664l4.719 7.562a1.408 1.408 0 0 1-1.195 2.149H3.28a1.408 1.408 0 0 1-1.194-2.149l4.718-7.562A1.4 1.4 0 0 1 8 2.657Zm.469 7.53H7.53v.938h.938v-.937Zm0-4.25H7.53V9.25h.938V5.938Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWarn);
export default ForwardRef;